import React from 'react';
import PropTypes from 'prop-types';
import styles from '../QuestionDisplay.scss';
import { t } from '../../../services/i18nService';

import stateCacheService from '../../../services/StateCache';
import storeManager from '../../../store/StoreManager';
import itemFlagActions from '../../../actions/ItemFlagActions';
import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import flaggedItemsReader from '../../../store/readHelpers/FlaggedItemsReader';
import marketplacePropertiesService from '../../../services/MarketplacePropertiesService';

const HiddenItemFlagButton = ({ orderNumber, contentRevisionId, responseIdentifier, choiceIdentifier }) => {
    const { dispatch } = storeManager.getStore();
    const identifierSuffix = orderNumber ? `-${orderNumber}` : '';
    const identifier = `${contentRevisionId}${identifierSuffix}`;
    const isItemFlagged = flaggedItemsReader.isItemFlagged(identifier);

    const setFocusedFlag = () => {
        dispatch(
            itemFlagActions.focusItemFlag(identifier),
        );

        scorableItemNumberingService.navigateToScorableItem(contentRevisionId, responseIdentifier, choiceIdentifier, true);
    };

    const clearFocusedFlag = () => {
        dispatch(
            itemFlagActions.focusItemFlag(null),
        );
    };

    const toggleFlag = () => {
        dispatch(
            itemFlagActions.toggleItemFlag(identifier, !isItemFlagged),
        );

        const state = storeManager.getState();
        const stateCache = stateCacheService.getStateCacheInstance();
        stateCache.setFlaggedItems(state.itemFlag.flaggedItems);
    };

    const label = isItemFlagged
        ? `${t('question.unflagQuestionNumber')} ${orderNumber}`
        : `${t('question.flagQuestionNumber')} ${orderNumber}`;

    // Exposed as an attribute rather than a child, so a note cannot capture it.
    const gapMatchNotesTextHandlingEnabled = marketplacePropertiesService.isGapMatchNotesTextHandlingEnabled();

    return (
        <button
            onClick={toggleFlag}
            onFocus={setFocusedFlag}
            onBlur={clearFocusedFlag}
            aria-pressed={isItemFlagged}
            aria-label={gapMatchNotesTextHandlingEnabled ? label : undefined}
            className={styles.hiddenFocus}
            id={identifier}
            tabIndex={0}
            data-question-id={contentRevisionId}
        >
            { !gapMatchNotesTextHandlingEnabled &&
                <span className="sr-only">
                    {isItemFlagged
                        ? `${t('question.unflagQuestionNumber')} ${orderNumber}`
                        : `${t('question.flagQuestionNumber')} ${orderNumber}`
                    }
                </span>
            }
        </button>
    );
};

HiddenItemFlagButton.propTypes = {
    orderNumber: PropTypes.string,
    contentRevisionId: PropTypes.number.isRequired,
    responseIdentifier: PropTypes.string.isRequired,
    choiceIdentifier: PropTypes.string,
};

export default HiddenItemFlagButton;
